import { useEffect } from 'react';
import { Menu, MenuIcon, Popover, Position, UserIcon } from 'evergreen-ui';
import { useDispatch, useSelector } from 'react-redux';
import { AnchorComponent, ButtonLink, IconButton, LinkComponent } from '..';
import { getEducatorPageData } from '../../actions/educator';
import { useAppSelector } from 'store';
import { selectIsAuthenticated } from 'selectors';
import { Environment } from 'services/Environment';

export const SubdomainNavbar = () => {
    const hostname = window?.location?.hostname;
    const subdomain = hostname.split('.')[0];
    const { currentEducator: educator, loading } = useSelector((store) => store.educator);
    const isAuthenticated = useAppSelector(selectIsAuthenticated);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!educator.slug && educator.slug !== subdomain) {
            dispatch(getEducatorPageData(subdomain));
        }
    }, [dispatch, educator.slug, subdomain]);

    if (loading) return null;

    const renderAuthMenus = () => {
        if (isAuthenticated) {
            return (
                <Menu>
                    <Menu.Item is={AnchorComponent} href="/profile" target="_self">
                        Profile
                    </Menu.Item>
                    <Menu.Item
                        onSelect={() => {
                            window.location.href = '/logout';
                        }}
                    >
                        Log Out
                    </Menu.Item>
                </Menu>
            );
        }

        return (
            <Menu>
                <Menu.Item
                    is={LinkComponent}
                    onClick={() => {
                        window.location.href = `${Environment.MARKETPLACE_URL}/login?redirect=${encodeURIComponent(window.location.href)}`;
                    }}
                >
                    Login
                </Menu.Item>
            </Menu>
        );
    };

    const renderMobileMenu = () => (
        <Menu>
            <Menu.Item is={LinkComponent} to="/">
                Courses
            </Menu.Item>
            <Menu.Item is={LinkComponent} to="/about">
                About
            </Menu.Item>
            {educator.memberships && educator.memberships.length ? (
                <Menu.Item is={LinkComponent} to="/memberships">
                    Memberships
                </Menu.Item>
            ) : null}
            {!educator.vouchers_app_installed ? null : (
                <Menu.Item is={LinkComponent} to="/gift-checkout">
                    Vouchers
                </Menu.Item>
            )}
        </Menu>
    );

    return (
        <div
            className="container"
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingTop: '20px',
            }}
        >
            <LinkComponent to="/">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {educator.logo_url ? (
                        <img
                            src={educator.logo_url}
                            style={{ height: '30px', marginRight: '10px', borderRadius: '5px' }}
                            alt="educator logo"
                        />
                    ) : null}
                    <h2 style={{ margin: 0 }}>{educator.name}</h2>
                </div>
            </LinkComponent>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Popover content={renderMobileMenu()} position={Position.BOTTOM_RIGHT}>
                    <IconButton
                        children={<MenuIcon />}
                        className="show-only-on-mobile"
                        style={{ marginRight: '10px' }}
                    />
                </Popover>
                <ButtonLink
                    to="/"
                    margin="0 10px 0 0"
                    children="Courses"
                    className="hide-on-mobile"
                />
                <ButtonLink
                    to="/about"
                    margin="0 10px 0 0"
                    children="About"
                    className="hide-on-mobile"
                />
                {!educator.vouchers_app_installed ? null : (
                    <ButtonLink
                        to="/gift-checkout"
                        margin="0 10px 0 0"
                        children="Vouchers"
                        className="hide-on-mobile"
                    />
                )}
                <Popover content={renderAuthMenus()} position={Position.BOTTOM_RIGHT}>
                    <IconButton desc="Mobile profile dropdown button" margin="0 10px 0 0">
                        <UserIcon size={20} color={isAuthenticated ? 'var(--blue)' : 'black'} />
                    </IconButton>
                </Popover>
            </div>
        </div>
    );
};
